import ItemCard from 'components/Utils/ItemCard';
import { startDemo } from 'services/SupaDemo/supaDemo';

interface IRenderDemoProps {
  id: string;
  stepNr: number;
  title: string;
  subText: string;
}

export const RenderDemo = (props: IRenderDemoProps) => {
  //
  // Main render
  //
  return (
    <ItemCard
      title={props.title}
      description={props.subText}
      onClick={() => startDemo(props.id)}
      stepNr={props.stepNr}
      width={250}
      height={150}
    ></ItemCard>
  );
};
